import type { VoidFunctionComponent } from 'react';

import { useDresser } from '../../contexts/DrawerContext';
import Drawer from '../generic/Drawer';

const Dresser: VoidFunctionComponent = () => {
  const { drawerContents, popDrawer, clearDrawers, widthPercent } = useDresser();

  const contentToShow = drawerContents[0];

  // Use custom onBack if provided, otherwise use popDrawer
  const handleBack = contentToShow?.drawerProps?.onBack ?? popDrawer;

  return (
    <Drawer
      isOpen={!!contentToShow}
      onBack={drawerContents.length > 1 ? handleBack : undefined}
      widthPercentage={widthPercent}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...contentToShow?.drawerProps ?? {}}
      onClose={() => {
        contentToShow?.drawerProps?.onClose?.();
        clearDrawers();
      }}
    >
      {drawerContents.map((item, index) => (
        <div
          key={item.id}
          style={{
            // We set display: none on all content except the first one so that it's still in the
            // DOM but not visible. This is to preserve the state of the drawers even when they're
            // not the currently displayed one.
            display: index === 0 ? 'block' : 'none',
          }}
        >
          {item.content}
        </div>
      ))}
    </Drawer>
  );
};

export default Dresser;
